import React from "react";
import { Brain, Smartphone, Cog, Users } from "lucide-react";

const About = () => {
  const services = [
    {
      icon: Brain,
      title: "AI & Machine Learning Solutions",
      description: "Intelligent systems that learn and adapt"
    },
    {
      icon: Smartphone,
      title: "Web & Mobile Application Development",
      description: "Cross-platform solutions for modern needs"
    },
    {
      icon: Cog,
      title: "IoT & Automation Systems",
      description: "Connected devices for smarter operations"
    },
    {
      icon: Users,
      title: "Digital Transformation Consulting",
      description: "Strategic guidance for digital evolution"
    }
  ];

  return (
    <section id="about" className="about">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">About Us</h2>
        </div>
        
        <div className="about-content">
          <div className="about-intro">
            <h3 className="about-subtitle">Who We Are</h3>
            <p className="about-description">
              DoubleTap Innovations & Technologies Private Limited is a forward-thinking tech startup 
              committed to transforming ideas into reality. Our mission is to bridge the gap between 
              innovation and everyday life, delivering impactful solutions for businesses, communities, 
              and individuals.
            </p>
          </div>

          <div className="services-section">
            <h3 className="services-title">What We Do</h3>
            <div className="services-grid">
              {services.map((service, index) => (
                <div key={index} className="service-card">
                  <div className="service-icon">
                    <service.icon />
                  </div>
                  <h4 className="service-title">{service.title}</h4>
                  <p className="service-description">{service.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="approach-section">
            <p className="approach-text">
              Our approach combines creativity, precision engineering, and a customer-first mindset 
              to create solutions that are not just functional, but game-changing.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;